import React from 'react';
import { Mail, Instagram } from 'lucide-react';
import { FOOTER } from '../constants/testIds';

const Footer = () => {
  return (
    <footer 
      id="contacto"
      data-testid={FOOTER.section}
      className="bg-[#142A1D] text-[#FDFBF7] py-16"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="heading-serif text-3xl mb-4 font-light">Legatum Coffee</h3>
            <p className="text-[#F2EBE1] opacity-80 leading-relaxed">
              Café de especialidad del Huila, Colombia. Un legado de calidad y tradición.
            </p>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className="font-medium mb-4 uppercase tracking-wider text-sm">Contacto</h4>
            <div className="space-y-3">
              <a 
                data-testid={FOOTER.contactEmail}
                href="mailto:legatumcoffee@gmail.com"
                className="flex items-center gap-2 text-[#F2EBE1] hover:text-[#B58A3F] transition-colors"
              >
                <Mail className="w-4 h-4" strokeWidth={1.5} />
                <span>legatumcoffee@gmail.com</span>
              </a>
            </div>
          </div>
          
          {/* Social */}
          <div>
            <h4 className="font-medium mb-4 uppercase tracking-wider text-sm">Síguenos</h4>
            <div 
              data-testid={FOOTER.socialLinks}
              className="flex gap-4"
            >
              <a
                href="https://instagram.com/legatumcoffee"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 hover:bg-[#2B4C36] rounded-lg transition-colors flex items-center gap-2 group"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" strokeWidth={1.5} />
                <span className="text-sm opacity-80 group-hover:opacity-100 transition-opacity">@legatumcoffee</span>
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-[#2B4C36] mt-12 pt-8 text-center text-[#F2EBE1] opacity-60 text-sm">
          <p>© {new Date().getFullYear()} Legatum Coffee. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
